import moment from 'moment';

export const checkIsExpired = (date: string) => {
	const now = moment().add(1, 's');
	const expires = moment(date);
	return now.isAfter(expires);
};
